var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_6606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16.2449 16 16.4813 16.09 16.6644 16.2527C16.8474 16.4155 16.9643 16.6397 16.993 16.883L17 17V21C17 21.2449 16.91 21.4813 16.7473 21.6644C16.5845 21.8474 16.3603 21.9643 16.117 21.993L16 22H8C7.75507 22 7.51866 21.91 7.33563 21.7473C7.15259 21.5845 7.03566 21.3603 7.007 21.117L7 21V17C7.00003 16.7551 7.08996 16.5187 7.25272 16.3356C7.41547 16.1526 7.63975 16.0357 7.883 16.007L8 16H16ZM19 7C19.7956 7 20.5587 7.31607 21.1213 7.87868C21.6839 8.44129 22 9.20435 22 10V17C22 17.5304 21.7893 18.0391 21.4142 18.4142C21.0391 18.7893 20.5304 19 20 19H19V16C19 15.4696 18.7893 14.9609 18.4142 14.5858C18.0391 14.2107 17.5304 14 17 14H7C6.46957 14 5.96086 14.2107 5.58579 14.5858C5.21071 14.9609 5 15.4696 5 16V19H4C3.46957 19 2.96086 18.7893 2.58579 18.4142C2.21071 18.0391 2 17.5304 2 17V10C2 9.20435 2.31607 8.44129 2.87868 7.87868C3.44129 7.31607 4.20435 7 5 7H19ZM17 9H15C14.7451 9.00028 14.5 9.09788 14.3146 9.27285C14.1293 9.44782 14.0178 9.68695 14.0028 9.94139C13.9879 10.1958 14.0707 10.4464 14.2343 10.6418C14.3979 10.8373 14.6299 10.9629 14.883 10.993L15 11H17C17.2549 10.9997 17.5 10.9021 17.6854 10.7272C17.8707 10.5522 17.9822 10.313 17.9972 10.0586C18.0121 9.80416 17.9293 9.55362 17.7657 9.35817C17.6021 9.16271 17.3701 9.0371 17.117 9.007L17 9ZM17 2C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V5H6V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H17Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_6606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintericon);
export default __webpack_public_path__ + "static/media/printer.icon.4201d361b309f9b7e0e1c9a9df697c3c.svg";
export { ForwardRef as ReactComponent };